module.exports = __webpack_public_path__ + "basic.webp?63bcea37099b599f479fd8d06b33e866";